/**
 * File record category values
 */
export enum FileRecordCategoryEnum {
	IMAGE = 'image',
	DOCUMENT = 'document',
}
